import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-73cd3310"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "home-wrapper"
};
const _hoisted_2 = {
  class: "banner-wrapper"
};
const _hoisted_3 = {
  class: "home-list-content"
};
const _hoisted_4 = {
  class: "course-resource"
};
const _hoisted_5 = {
  class: "first-module-wrapper"
};
const _hoisted_6 = {
  class: "course-content"
};
const _hoisted_7 = {
  key: 0,
  class: "first-news-box"
};
const _hoisted_8 = {
  key: 1,
  class: "empty-box"
};
const _hoisted_9 = {
  class: "user-box"
};
const _hoisted_10 = {
  key: 0,
  class: "news-box"
};
const _hoisted_11 = {
  class: "second-module-box"
};
const _hoisted_12 = {
  key: 1,
  class: "lecture-box"
};
const _hoisted_13 = {
  class: "footer-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_BannerList = _resolveComponent("BannerList");

  const _component_Workspace = _resolveComponent("Workspace");

  const _component_News = _resolveComponent("News");

  const _component_Empty = _resolveComponent("Empty");

  const _component_UserCard = _resolveComponent("UserCard");

  const _component_NewsTwo = _resolveComponent("NewsTwo");

  const _component_MoocCourse = _resolveComponent("MoocCourse");

  const _component_SpocCourse = _resolveComponent("SpocCourse");

  const _component_TrainingProgram = _resolveComponent("TrainingProgram");

  const _component_Lecture = _resolveComponent("Lecture");

  const _component_TeachingCenterList = _resolveComponent("TeachingCenterList");

  const _component_TeacherList = _resolveComponent("TeacherList");

  const _component_DataDisplay = _resolveComponent("DataDisplay");

  const _component_Link = _resolveComponent("Link");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Head, {
    menuCode: $data.menuCode,
    onGetUserInfo: $options.getUserInfo,
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event),
    onUserRole: $options.getZhsRole
  }, null, 8, ["menuCode", "onGetUserInfo", "menuInfo", "onUserRole"]), _createElementVNode("div", _hoisted_2, [$data.bannerItem && $data.bannerItem.home_open ? (_openBlock(), _createBlock(_component_BannerList, {
    key: 0
  })) : _createCommentVNode("", true), _ctx.$schoolId == 954 ? (_openBlock(), _createBlock(_component_Workspace, {
    key: 1,
    zhsRole: $data.zhsRole,
    userInfo: $data.userInfo
  }, null, 8, ["zhsRole", "userInfo"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [$data.newsItemArr.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_News, {
    menu: $data.newsItemArr[0]
  }, null, 8, ["menu"])])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])), _createElementVNode("div", _hoisted_9, [_ctx.$schoolId == 954 ? (_openBlock(), _createBlock(_component_Workspace, {
    key: 0
  })) : (_openBlock(), _createBlock(_component_UserCard, {
    key: 1,
    userInfo: $data.userInfo,
    zhsRole: $data.zhsRole
  }, null, 8, ["userInfo", "zhsRole"]))])])]), $data.newsItemArr.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [($data.newsItemArr.length - 1) % 2 == 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.newsItemArr, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: item.id
    }, [index !== 0 && index % 2 === 1 ? (_openBlock(), _createBlock(_component_News, {
      key: 0,
      menu: item,
      contentWidth: $data.newsHalfWidth,
      isPadding: 1
    }, null, 8, ["menu", "contentWidth"])) : _createCommentVNode("", true), index !== 0 && index % 2 === 0 ? (_openBlock(), _createBlock(_component_NewsTwo, {
      key: 1,
      menu: $data.newsItemArr[index],
      contentWidth: $data.newsHalfWidth
    }, null, 8, ["menu", "contentWidth"])) : _createCommentVNode("", true)]);
  }), 128)) : _createCommentVNode("", true), ($data.newsItemArr.length - 1) % 2 == 1 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($data.newsItemArr, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: item.id
    }, [index === $data.newsItemArr.length - 1 ? (_openBlock(), _createBlock(_component_News, {
      key: 0,
      menu: item,
      contentWidth: $data.newsWidth,
      isPadding: 0
    }, null, 8, ["menu", "contentWidth"])) : index !== 0 && index % 2 == 1 ? (_openBlock(), _createBlock(_component_News, {
      key: 1,
      menu: item,
      contentWidth: $data.newsHalfWidth,
      isPadding: 1
    }, null, 8, ["menu", "contentWidth"])) : index !== 0 && index % 2 == 0 ? (_openBlock(), _createBlock(_component_NewsTwo, {
      key: 2,
      menu: item,
      contentWidth: $data.newsHalfWidth
    }, null, 8, ["menu", "contentWidth"])) : _createCommentVNode("", true)]);
  }), 128)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sortItem, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["second-module-wrapper", `second-module-wrapper${index}`]),
      key: item.id
    }, [_createElementVNode("div", _hoisted_11, [item.function_id == 10401 ? (_openBlock(), _createBlock(_component_MoocCourse, {
      key: 0,
      menu: item,
      userInfo: $data.userInfo,
      zhsRole: $data.zhsRole,
      class: "course-item"
    }, null, 8, ["menu", "userInfo", "zhsRole"])) : _createCommentVNode("", true), item.function_id == 10402 ? (_openBlock(), _createBlock(_component_SpocCourse, {
      key: 1,
      menu: item,
      userInfo: $data.userInfo,
      zhsRole: $data.zhsRole,
      class: "course-item"
    }, null, 8, ["menu", "userInfo", "zhsRole"])) : item.function_id == 17100 ? (_openBlock(), _createBlock(_component_TrainingProgram, {
      key: 2,
      menu: item
    }, null, 8, ["menu"])) : _createCommentVNode("", true)])], 2);
  }), 128)), $data.lectureItem && $data.lectureItem.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.lectureItem, item => {
    return _openBlock(), _createBlock(_component_Lecture, {
      key: item.id,
      menu: item
    }, null, 8, ["menu"]);
  }), 128))])) : _createCommentVNode("", true), $data.teachingCenterItem && $data.teachingCenterItem.function_id == '51001' && $data.teachingCenterItem.home_open ? (_openBlock(), _createBlock(_component_TeachingCenterList, {
    key: 2,
    menu: $data.teachingCenterItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true)]), $data.teacherItem && $data.teacherItem.function_id == '10501' && $data.teacherItem.home_open ? (_openBlock(), _createBlock(_component_TeacherList, {
    key: 0,
    menu: $data.teacherItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true)]), $data.dataItem && $data.dataItem.home_open ? (_openBlock(), _createBlock(_component_DataDisplay, {
    key: 0,
    menu: $data.dataItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [$data.footerItem && $data.footerItem.home_open ? (_openBlock(), _createBlock(_component_Link, {
    key: 0,
    menu: $data.footerItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true), _createVNode(_component_Footer, {
    menu: $data.footerItem,
    linkOpen: $data.footerItem && $data.footerItem.home_open
  }, null, 8, ["menu", "linkOpen"])])])]);
}